import { LOGIN_START, LOGIN_SUCCESS, LOGIN_ERROR, LOGIN_RESET,LOGOUT,LOGIN_REVALIDATE, SET_STRUCTURE } from '../types';

// redux-persist rehydrata este estado desde storage (ver REHYDRATE en
// reducers/index.js) — el estado inicial acá solo cubre el primer render,
// antes de que la rehidratación ocurra.
const initialState = {
  userData: null,
  token: null,
  isLogged: false,
  commercialStructure: null,
  commercialStructureName: null,
  commercialStIdSelected: null,
  commercialStNameSelected: null,
  cycle: null,
  error: null
};

const  login=(state = initialState, action) => {
  switch (action.type) {
    case LOGIN_START:
      return { ...state };
     
    case LOGIN_SUCCESS:
      return {
        ...state,
        userData: {
          id: action.payload.data.id,
          name: action.payload.data.name,
          photo:action.payload.data.photo,
          commercialStructure: action.payload.data.commercialStructure,
          commercialStructureName: action.payload.data.commercialStructureName,
          commercialStSelectedId: action.payload.data.commercialStructure,
          commercialStSelectedName: action.payload.data.commercialStructureName,
          cycle: action.payload.data.cycle,
        },
        isLogged: true,
        token: action.payload.data.token,
        error: null,
      };
   
    case LOGIN_ERROR:
      return {
        ...state,
        isLogged: false,
        userData: null,
        error: action.payload
      };
    case SET_STRUCTURE:
      return {
        ...state,
        userData: {
        commercialStIdSelected: action.payload.commercialStIdSelected,
        commercialStNameSelected: action.payload.commercialStNameSelected,
        },
      };
    case LOGIN_REVALIDATE:
        return {
          ...state,
          isLogged: true,
          token: action.payload.data.token,
          error: null,
        };
   
    case LOGIN_RESET:
        return {
          ...state,
          isLogged: false,
          userData: null,
          error: null
        };
    
    case LOGOUT:
      state = {}
      return {
        ...state,
        userData: null,
        isLogged: false,
        error: null
      }
   
    default:
      return state;
  }
}

export default login;